"use strict";

exports.__esModule = true;
exports.EmptySelectionTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _RenderMeasureTable = require("./RenderMeasureTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var EmptySelectionTable = exports.EmptySelectionTable = function EmptySelectionTable(props) {
  var tableProps = props.tableProps,
    columns = props.columns;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "aggregate-measure-table-element-empty-selection"
  }, /*#__PURE__*/_react["default"].createElement(_RenderMeasureTable.RenderMeasureTable, _extends({}, tableProps, {
    columns: columns,
    data: [],
    pages: 0,
    noDataText: "Make selection to view data"
  })));
};